import React, { Component } from 'react';
import styled from 'styled-components';

export default class NotFound extends Component {
	render () {
		return (
			<NotFoundText>
				<p>The page you're looking for may have been renamed or removed. We apologise for any inconvenience.</p>
			</NotFoundText>
		);
	}
};

const NotFoundText = styled.section`

	padding: 100px 20px;
	margin: auto;
	text-align: center;
	font-size: 18px;

`



// WEBPACK FOOTER //
// ./client/scenes/NotFound/index.js